import ApplicationSerializer from './application';

export default ApplicationSerializer.extend({
  serialize(object) {
    const payload = ApplicationSerializer.prototype.serialize.apply(this, arguments);
    const objects = object.models || [];

    payload.meta = {
      total: objects.length,
      'device-types': objects.mapBy('deviceType').uniq().compact(),
      // Sometimes there are null or empty wifinetwork SSIDS.
      // That's why we are not `.compact()` on `wifi-networks`
      'wifi-networks': objects.mapBy('wifiNetwork').uniq(),
    };

    return payload;
  },
});
